module.exports = __webpack_public_path__ + "static/platinum-be9c094eeef91119cbde20c38fbdc9cd.png";